/**
 * BCP-47 recognition locale for each Dynamics language (LCID) the app offers, as
 * listed in `LocalizationService.languages`. A language added there needs an entry
 * here before a rep using it can dictate.
 */
export const SPEECH_LOCALE_BY_LCID: Readonly<Record<string, string>> = Object.freeze({
  '1031': 'de-DE',
  '1033': 'en-US',
  '1036': 'fr-FR',
  '1040': 'it-IT',
  '1041': 'ja-JP',
  '1043': 'nl-NL',
  '1055': 'tr-TR',
  '2052': 'zh-CN',
  '2070': 'pt-PT',
  '3082': 'es-ES',
});

/**
 * The recognition locale for an LCID such as `LocalizationService.selectedLanguage.localeID`.
 *
 * @returns The BCP-47 locale, or `undefined` for a missing LCID or one the app does not offer.
 */
export function speechLocaleForLcid(lcid: string | number | null | undefined): string | undefined {
  if (lcid === null || lcid === undefined) {
    return undefined;
  }
  const key = `${lcid}`.trim();
  return Object.prototype.hasOwnProperty.call(SPEECH_LOCALE_BY_LCID, key) ? SPEECH_LOCALE_BY_LCID[key] : undefined;
}
